import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Suppress non-critical Navigator LockManager warnings/errors from Supabase
const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;

console.warn = (...args: any[]) => {
  const message = args.join(' ');
  // Filter out Supabase LockManager warnings
  if (message.includes('Navigator LockManager') || 
      message.includes('lock:sb-') || 
      message.includes('Acquiring an exclusive')) {
    return; // Suppress this warning
  }
  originalConsoleWarn.apply(console, args);
};

console.error = (...args: any[]) => {
  const message = args.join(' ');
  // Filter out Supabase LockManager errors (non-critical)
  if (message.includes('Navigator LockManager') || 
      message.includes('lock:sb-') || 
      message.includes('Acquiring an exclusive') ||
      message.includes('immediately failed')) {
    return; // Suppress this error
  }
  originalConsoleError.apply(console, args);
};

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

